import { render, staticRenderFns } from "./form-tailwind.vue?vue&type=template&id=4fe4e384&"
import script from "./form-tailwind.vue?vue&type=script&lang=js&"
export * from "./form-tailwind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports